import HomeScorecardCard from "./homeScorecardCard";

const CardScorecardAssessWildfireRisk = ({
  hoveredTab,
  onTabHover,
  onTabLeave,
}) => {
  return (
    <HomeScorecardCard
      hoveredTab={hoveredTab}
      onTabHover={onTabHover}
      onTabLeave={onTabLeave}
      id="scorecard-assess"
      title="Assess Wildfire Risk and Readiness in Your Area"
      titleColor="var(--green)"
      image="./images/home/card-assess-wildfire-risk.png"
      content={[
        {
          type: "paragraph",
          color: "var(--white)",
          text: "The ARISE-US/CrowdDoing CWPC Community Wildfire Resilience Scorecard follows the United Nations’ 10 Essentials framework and incorporates cutting-edge resilience principles with a diverse range of readiness factors.",
        },
        {
          type: "paragraph",
          color: "var(--white)",
          text: "The scorecard enhances existing community wildfire mitigation plans or can serve as an independent assessment tool.",
        },
        {
          type: "paragraph",
          color: "var(--white)",
          text: "With our comprehensive approach, communities become prepared to develop an action plan that substantially reduces wildfire risk through integrated planning, mitigation, and governance.",
        },
      ]}
    />
  );
};

export default CardScorecardAssessWildfireRisk;
